(function () {
    "use strict";

    angular
        .module("UndergroundWebApp")
        .controller("AccessItemStatisticsController", AccessItemStatisticsController);

    AccessItemStatisticsController.$inject = [
        "$scope",
        "accessItemsService",
        "$translate",
        "filterStateService",
        "$timeout",
        '$stateParams',
        'kendoGridUtility',
    ];

    function AccessItemStatisticsController(
        $scope,
        accessItemsService,
        $translate,
        filterStateService,
        $timeout,
        $stateParams,
        kendoGridUtility,
    ) {
        $scope.locationId = null;
        $scope.dateRange = {
            value: "month",
            label: $translate.instant("CONTSANT_DATE_RANGE_MONTH"),
            setter: (date) => date.setMonth(date.getMonth() - 1),
        };

        $scope.charts = [];
        $scope.getChartData = getChartData;
        $scope.processChartData = processChartData;
        $scope.isDateFilterWarningVisible = false;
        $scope.dateFilterWarningMessage = '';

        // to hide Back to location button
        $scope.dataItem = {};

        $scope.statisticsAccessEventsGridOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: readStatisticAccessEvents,
                },
                schema: {
                    model: {
                        fields: {
                            time: { type: "date" },
                            outcome: {},
                            uid: {},
                        },
                    },
                },
                pageSize: 70,
                sort: filterStateService.getSortFromQueryString(),
                filter: filterStateService.getFilterFromQueryString(),
            }),
            pageable: {
                refresh: true,
                pageSizes: [20, 50, 100, 200],
                buttonCount: 5,
            },
            columns: [
                {
                    field: "time",
                    title: $translate.instant(
                        "STATISTICS_CONTROLLER_GRID_TIME"
                    ),
                    template: function(dataItem) {
                        var dt = kendoGridUtility.getLocalDateCell(dataItem.time);
                        return kendo.toString(dt, $translate.instant("G_DEFAULT_DATE_FORMAT"));
                    },
                    width: "auto",
                    lockable: false,
                },
                {
                    field: "outcome",
                    title: $translate.instant(
                        "STATISTICS_CONTROLLER_GRID_OUTCOME"
                    ),
                    width: "auto",
                    lockable: false,
                    template: function (dataItem) {
                        var translationKey =
                            dataItem.outcome;
                        if (translationKey) {
                            return $translate.instant(translationKey);
                        }
                        return "";
                    },
                },
                {
                    field: "nfcUid",
                    title: $translate.instant("STATISTICS_CONTROLLER_DEVICE"),
                    width: "auto",
                    lockable: false,
                },
            ],
            scrollable: {
                virtual: true,
            },
            sortable: true,
            filterable: true,
            noRecords: true,
            selectable: false,
            resizable: true,
            sort: filterStateService.storeGridSortInQueryString,
            filter: filterStateService.storeGridFilterInQueryString,
            groupable: false,
        };

        $scope.dateRangeOptions = [
            {
                value: "week",
                label: $translate.instant("CONTSANT_DATE_RANGE_WEEK"),
                setter: (date) => date.setDate(date.getDate() - 7),
            },
            {
                value: "half-month",
                label: $translate.instant("CONTSANT_DATE_RANGE_HALF_MONTH"),
                setter: (date) => date.setDate(date.getDate() - 15),
            },
            {
                value: "month",
                label: $translate.instant("CONTSANT_DATE_RANGE_MONTH"),
                setter: (date) => date.setMonth(date.getMonth() - 1),
            },
            {
                value: "custom",
                label: $translate.instant("CONTSANT_DATE_RANGE_CUSTOM"),
            },
        ];

        function getChartData() {
            var fromDate = moment($scope.dateRange.from);
            var toDate = moment($scope.dateRange.to);

            if (!fromDate.isValid() || !toDate.isValid()) {
                $scope.isDateFilterWarningVisible = true;
                $scope.dateFilterWarningMessage = $translate.instant("STATISTICS_CONTROLLER_INVALID_DATE_RANGE");
                return;
            }

            if (fromDate.isAfter(toDate)) {
                $scope.isDateFilterWarningVisible = true;
                $scope.dateFilterWarningMessage = $translate.instant("STATISTICS_CONTROLLER_WRONG_INTERVAL");
                return;
            }

            var diffInDays = toDate.diff(fromDate, 'days');
            if (diffInDays > 31) {
                $scope.isDateFilterWarningVisible = true;
                $scope.dateFilterWarningMessage = $translate.instant("STATISTICS_CONTROLLER_TOO_BIG_INTERVAL");
                return;
            }
            $scope.isDateFilterWarningVisible = false;
            $scope.dateFilterWarningMessage = '';
            accessItemsService
                .getOpenAccessEvents(
                    $stateParams.cardNumber,
                    fromDate.format("YYYY-MM-DD"),
                    toDate.format("YYYY-MM-DD")
                )
                .then(function (statistics) {
                    $scope.statistics = statistics;
                    var charts = {
                        dataSource: {
                            data: $scope.processChartData(statistics),
                        },
                        series: [
                            {
                                type: "column",
                                field: "count",
                                categoryField: "date",
                                color: "purple",
                                labels: {
                                    visible: true,
                                    position: "top",
                                    format: "{0}",
                                },
                            },
                        ],
                        categoryAxis: {
                            labels: {
                                rotation: -45,
                            },
                        },
                        valueAxis: {
                            min: 0,
                            majorUnit: 1,
                        },
                        tooltip: {
                            visible: true,
                            format: "{0}",
                        },
                        seriesClick: function (e) {
                            if (!e.originalEvent) return;
                            onChartColumnClick(e)
                        },
                    };

                    $scope.charts = [charts];
                    $timeout(() => {
                        if (
                            $scope.statisticsAccessEventsGrid &&
                            $scope.statisticsAccessEventsGrid.dataSource
                        ) {
                            $scope.statisticsAccessEventsGrid.dataSource.read();
                        } else {
                            console.warn(
                                "Grid or datasource not available yet."
                            );
                        }
                    });
                });
        }

        function processChartData(data) {
            let groupedData = {};

            data.forEach((item) => {
                let date = item.eventData.access.event.time.split("T")[0]; // Extract YYYY-MM-DD
                groupedData[date] = (groupedData[date] || 0) + 1;
            });

            // Convert to array format for Kendo
            return Object.keys(groupedData).map((date) => ({
                date: date,
                count: groupedData[date],
            }));
        }

        function readStatisticAccessEvents(e) {
            if ($scope.statistics) {
                const gridElements = $scope.statistics.map((event) => {
                    event.eventData.access.event.origin.nfc.nfcUid = event.eventData.access.event.origin.nfc.uid || "";
                    return {
                        time: event.eventData.access.event.time,
                        outcome: event.eventData.access.event.outcome,
                        nfcUid: event.eventData.dev_Id,
                    };
                });
                e.success(gridElements);
            } else {
                console.warn("No openAccessEvents available!");
                e.success([]);
            }
        }
        function onChartColumnClick(e) {
            const clickedDate = e.category; 
            if ($scope.statisticsAccessEventsGrid) {
                let filter = {};
                if ($scope.clickedDate === clickedDate) {
                    $scope.clickedDate = null;
                } else {
                    $scope.clickedDate = clickedDate;
                    filter = {
                        field: "time",
                        operator: function (itemDate) {
                            return (
                                moment(itemDate).format("YYYY-MM-DD") ===
                                clickedDate
                            );
                        },
                    };
                }
                $scope.statisticsAccessEventsGrid.dataSource.filter(filter);
            }
        }
    }
})();
